export default "__VITE_ASSET__DBEU5r3O__"